import {ActionCompletionDialogComponent} from '../common/action-completion-dialog/action-completion-dialog.component';
import {ActivatedRoute} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {CommonService} from '../services/common.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ConfirmActionDialogComponent} from '../common/confirm-action-dialog/confirm-action-dialog.component';
import {CreateLoadingAccessoryRequestComponent} from './loading-order-creation/create-loading-accessory-request.component';
import {LoadingService} from '../services/loading.service';
import {MatDialog} from '@angular/material';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material';
import {ToastMessagesService} from '../services/toast-messages.service';

@Component({
  templateUrl: './accessory-request-details.component.html'
})
export class AccessoryRequestDetailsComponent implements OnInit {
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public dataSource: MatTableDataSource<any>;
  public orderDetails: any;
  public basicDetailsConfig: any;
  public showBasicInfo: boolean;
  private user: any;
  details: any = [];
  pageInitialized: boolean;
  order: any;
  public tableContainerWidth: any;
  public canCancelMaterial: boolean;

  public displayedColumns: string[] = ['serial_number', 'material_id', 'material_description', 'has_cases', 'accessory_category_description', 'value_to_load'];

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              public commonService: CommonService,
              private loadingService: LoadingService,
              private matDialog: MatDialog,
              private toastMessagesService: ToastMessagesService) {
    this.pageInitialized = false;
    this.showBasicInfo = false;
    this.dataSource = new MatTableDataSource<any>([]);
    this.canCancelMaterial = false;
  }

  public async ngOnInit(): Promise<any> {
    try {
      this.tableContainerWidth = window.innerWidth - 310;
      this.activatedRoute.params.subscribe(async (params) => {
        this.loadingService.show();
        this.order = await this.commonService.getSimpleList(`accessory_request/${params.id}`);
        const parentRowRequest = await this.commonService.getListWithParameters(`accessory_request/web`, `id=${+params.id}`);
        const parentRow = parentRowRequest[0];
        this.orderDetails = {
          request_id: parentRow.id, // row id
          sale_point_id: parentRow.sale_point_id,
          recipient: parentRow.sale_point_customer_name,
          address: parentRow.sale_point_address,
          request_type_id: parentRow.type_id,
          status: parentRow.status_description_id
        };

        this.dataSource = new MatTableDataSource<any>(this.order);
        this.dataSource.paginator = this.commonService.setPaginatorTexts(this.paginator);
        this.dataSource.sort = this.sort;
        await this.initUser();
        this.pageInitialized = true;
        this.loadingService.hide();
      });
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  private async initUser() {
    this.user = await this.authService.getUser();
    this.initBasicInfo();
  }

  private async initBasicInfo() {
    this.showBasicInfo = true;
    this.basicDetailsConfig = {
      subtitle: [
        {
          title: 'Αριθμός Εντολής',
          value: this.orderDetails.request_id
        }
      ],
      title: 'Πληροφορίες Αίτησης Θηκών'
    };

    this.initializeActions();
  }

  private async initializeActions() {
    const actions = [];
    const action = {
      function: () => {
        this.initializeCreateAccessoryLoadingRequest();
      },
      showAction: this.canShow(),
      title: 'Δημιουργία Εντολής Φόρτωσης',
      icon: 'cloud_upload',
      color: 'green'
    };

    if (this.user.role_id === 1 || this.user.role_id === 10) {
      actions.push(action);
    } else if (this.user.role_alternate_name === 'hqManager') {
    } else {
      actions.push(action);
    }

    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = await this.commonService.showActions(this.user);
    } else {
      this.basicDetailsConfig.showActions = false;
    }
  }

  private canShow() {
    return (this.orderDetails.status === 6 || this.orderDetails.status === 7) &&
    this.user.role_alternate_name !== 'hqManager';
  }

  private async cancelRequest() {
    try {
      const redirectURL = decodeURIComponent('purchase_order_requests?tab=accessories');
      await this.commonService.updateObject(`accessory_request/cancel/${this.orderDetails.request_id}`, {});
      this.matDialog.open(ActionCompletionDialogComponent, {
        data: {
          buttonText: 'Πλοήγηση στις αιτήσεις',
          redirectURL
        }
      });
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  public canCancelRequestOrder() {
    return this.orderDetails.status === 6 && this.user && this.user.role_alternate_name !== 'hqManager';
  }

  public async confirmCancellation() {
    this.matDialog.open(ConfirmActionDialogComponent, {
      data: {
        confirmFunction: () => {
          this.cancelRequest();
        },
        message: `Είστε σίγουροι ότι θέλετε να ακυρώσετε την αίτηση με αριθμό ${this.orderDetails.request_id}?`,
        title: 'Ακύρωση Αίτησης'
      }
    });
  }

  private async initializeCreateAccessoryLoadingRequest() {
    this.loadingService.show();
    const users = await this.commonService.getListWithParameters('user', 'role_id=2 OR role_id = 13 OR role_id = 14');
    this.loadingService.hide();
    this.matDialog.open(CreateLoadingAccessoryRequestComponent, {
      data: {
        users,
        sale_point_id: this.orderDetails.sale_point_id,
        order_id: this.orderDetails.request_id
      }
    });
  }
}
